import reducer from 'state/direct-order/shipments/reducer';
import selectors from 'state/direct-order/shipments/selectors';
import actions from 'state/direct-order/shipments/actionCreators';
import effects from 'state/direct-order/shipments/effects';

export { selectors, actions, effects };

export default reducer;
